<!-- CARGANDO -->
<ng-container *ngIf="upload && !size">
  <div class="cf-dlg" style="min-width:380px">
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>cloud_upload</mat-icon></div>
      <div><h2 class="cf-dlg-title">Subiendo fichero…</h2></div>
    </div>
    <div class="cf-dlg-body" style="display:flex;flex-direction:column;align-items:center;gap:16px;padding:40px 24px">
      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
      <p style="margin:0;font-size:0.875rem;color:var(--cf-text-muted)">Por favor espera, no cierres la ventana</p>
    </div>
  </div>
</ng-container>

<!-- FORMULARIO -->
<ng-container *ngIf="!upload">
  <div class="cf-dlg" style="min-width:420px">

    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>insert_drive_file</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">Subir fichero</h2>
        <p class="cf-dlg-subtitle">Soportado: imágenes, PDF, DOCX, XLSX</p>
      </div>
    </div>

    <div class="cf-dlg-body">

      <!-- Error -->
      <div class="cf-dlg-mismatch" *ngIf="error">
        <mat-icon>error_outline</mat-icon>
        {{ error_msg }}
      </div>

      <!-- Completado -->
      <div *ngIf="done" style="display:flex;align-items:center;gap:8px;padding:12px 14px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;margin-bottom:12px">
        <mat-icon style="color:var(--cf-success,#16a34a);font-size:20px;width:20px;height:20px">check_circle</mat-icon>
        <span style="font-size:0.875rem;font-weight:600;color:var(--cf-success,#16a34a)">Fichero subido correctamente</span>
      </div>

      <ng-container *ngIf="!done">
        <!-- Nombre del fichero -->
        <app-input inputType="text" placeholder="Nombre identificativo" [isRequired]="true"
          [(ngModel)]="fileName"></app-input>

        <!-- Aviso de tamaño -->
        <div *ngIf="size" style="color:var(--cf-error,#dc2626);font-size:13px;margin-bottom:8px">
          La imagen debe ser superior a 200px
        </div>

        <!-- Selector de fichero -->
        <div style="margin-top:8px">
          <input type="file" (change)="uploadImage($event)"
            accept=".png,.jpg,.jpeg,.pdf,.xlsx,.docx" required
            style="font-size:13px;color:var(--cf-text-muted)" />
          <p style="margin:6px 0 0;font-size:12px;color:var(--cf-text-muted)">
            Una vez seleccionado, el fichero se subirá automáticamente.
          </p>
        </div>
      </ng-container>

    </div>

    <div class="cf-dlg-footer">
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="closeDialog()">
        {{ done ? 'Cerrar' : 'Cancelar' }}
      </button>
    </div>

  </div>
</ng-container>
